module.exports = __webpack_public_path__ + "static/media/people-carry-solid.8353fd1f.svg";